import { ServiceLanguage } from "@albertine/i18n";
import { z } from "zod";

export const chatSearchSchema = z.object({
    type: z.literal("proposal").optional(),
    id: z.string().min(1).optional(),
    request: z.string().min(1).optional(),
    locale: ServiceLanguage.optional(),
    parentOrigin: z.url().optional(),
    itemLinkPrefix: z
        .string()
        .regex(/^\/[^\s]*$/)
        .optional(),
});

export type ChatSearch = z.infer<typeof chatSearchSchema>;

export function resolveChatRequestId(search: ChatSearch): string | undefined {
    if (search.request) {
        return search.request;
    }

    if (search.type === "proposal") {
        return search.id;
    }

    return undefined;
}
